import { render, staticRenderFns } from "./LangSelectElem.vue?vue&type=template&id=1e7effee&"
import script from "./LangSelectElem.vue?vue&type=script&lang=js&"
export * from "./LangSelectElem.vue?vue&type=script&lang=js&"
import style0 from "./LangSelectElem.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports